import { Box, Button, Stack, styled, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';

import { aspectRatio } from 'utils/styles.utils';

import { IS_LOYALTY_ENABLED } from 'constants/loyalty.constants';
import { Routes } from 'constants/routes.constants';
import { useModalControl } from 'hooks/useModalControl';
import { useAccount } from 'queries/accounts/useAccount';

import LinkUnstyled from 'components/@common/LinkUnstyled';
import Icon from 'components/@icons/Icon';
import LoyaltyCardLandscape from 'components/@loyalty/LoyaltyCardLandscape';
import SaudiRewardsBalanceDialog from 'components/@saudi-rewards/SaudiRewardsBalanceDialog';
import SaudiRewardsCardLandscape from 'components/@saudi-rewards/SaudiRewardsCardLandscape';
import SaudiRewardsLinkAccountModal from 'components/@saudi-rewards/SaudiRewardsLinkAccountModal';

const LoyaltyCards = () => {
  const { account, loyaltyTier } = useAccount();

  const {
    open: openLinkAccount,
    onClose: onCloseLinkAccount,
    onOpen: onOpenLinkAccount,
  } = useModalControl();

  const {
    open: openBalance,
    onClose: onCloseBalance,
    onOpen: onOpenBalance,
  } = useModalControl();

  const handleSaudiRewardsCardClick = () => {
    if (!!account?.saudiRewardsMemberId) {
      onOpenBalance();
    } else {
      onOpenLinkAccount();
    }
  };

  return (
    <>
      <Stack sx={{ my: 5 }}>
        <Typography variant="h6" sx={{ mb: 2 }}>
          <FormattedMessage id="account.my_cards.title" />
        </Typography>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: { xs: 1, md: 2 },
          }}
        >
          <StyledCardButton onClick={handleSaudiRewardsCardClick}>
            <SaudiRewardsCardLandscape size="small" />
            <StyledIconButton>
              {!!account?.saudiRewardsMemberId ? (
                <Icon name="ChevronRight" />
              ) : (
                <Icon name="Plus" />
              )}
            </StyledIconButton>
          </StyledCardButton>

          {IS_LOYALTY_ENABLED && (
            <StyledCardButton
              component={LinkUnstyled}
              href={Routes.AccountLoyaltyTiers}
            >
              <LoyaltyCardLandscape tier={loyaltyTier} size="small" />
              <StyledIconButton>
                <Icon name="ChevronRight" />
              </StyledIconButton>
            </StyledCardButton>
          )}
        </Box>
      </Stack>
      <SaudiRewardsLinkAccountModal
        open={openLinkAccount}
        onClose={onCloseLinkAccount}
      />
      <SaudiRewardsBalanceDialog open={openBalance} onClose={onCloseBalance} />
    </>
  );
};

export default LoyaltyCards;

const StyledCardButton = styled(Button)({
  ...aspectRatio(16, 9),
  p: 0,
  alignItems: 'unset',
  display: 'flex',
  position: 'relative',
}) as typeof Button;

const StyledIconButton = styled('div')(({ theme }) => ({
  position: 'absolute',
  bottom: 8,
  right: 8,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: theme.vars.palette.grey[900],
  width: 24,
  height: 24,
  borderRadius: '50%',
  '&& svg': {
    width: 16,
    height: 16,
    minWidth: 16,
  },
}));
